import Repository from "../../repository";

export default {
    GetListCustomize: (payload) => Repository.post(`/api/customize-ver2/GetListCustomize`, payload),
    GetColumnNameShow: (payload) => Repository.post(`/api/customize-ver2/GetColumnNameShow`, payload),
    GetByTableName: (payload) => Repository.post(`/api/customize-ver2/GetByTableName`, payload),
    GetCustomizeByEntry: (payload) => Repository.post(`/api/customize-ver2/GetCustomizeByEntry`, payload),
    Add: (payload) => Repository.post(`/api/customize-ver2/Add`, payload),
    Edit: (payload) => Repository.post(`/api/customize-ver2/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/customize-ver2/Delete`, payload),
    AddRange: (payload) => Repository.post(`/api/customize-ver2/AddRange`, payload),
    EditRange: (payload) => Repository.post(`/api/customize-ver2/EditRange`, payload),
};
